import React, { useRef, useEffect, useState, useCallback } from 'react';

interface CanvasProps {
  image: string;
  alt: string;
  text: string | undefined;
  textStyles?: Record<string, any>
}

export const Canvas = (props: CanvasProps) => {
  const [ image, setImage ] = useState<HTMLImageElement>();

  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const getImageDimensions = () => {
      var img = new Image();
  
      img.onload = function() {
        setImage(img);
      }
  
      img.src = props.image;
    }

    getImageDimensions();
  }, [props.image]);

  const draw = useCallback((ctx: CanvasRenderingContext2D) => {
    if (!image) return;

    ctx.drawImage(image, 0, 0, image.width, image.height);
    
    // text
    if (props.text && props.text !== 'undefined') {
      const styles = {
        fontWeight: props.textStyles?.font?.weight || '400',
        fontSize: props.textStyles?.font?.size || 40,
        fontFamily: props.textStyles?.font?.family || 'sans-serif',
        textAlign: props.textStyles?.box?.align || 'left',
        left: props.textStyles?.box?.x || 0,
        top: props.textStyles?.box?.y || 0,
        color: props.textStyles?.font?.color || '#fff000'
      }

      ctx.font = `${styles.fontWeight} ${styles.fontSize}px ${styles.fontFamily}`;
      ctx.textAlign = styles.textAlign;
      ctx.textBaseline = 'top';
      ctx.fillStyle = styles.color;

      const top = (image.height * styles.top) / 100;
      const left = (image.width * styles.left) / 100;

      ctx.fillText(props.text, left, top);  
    }
  }, [image, props.text, props.textStyles])
  
  useEffect(() => {
    if (!image) {
      return;
    }

    const canvas = canvasRef.current as HTMLCanvasElement;
    const context = canvas.getContext('2d') as CanvasRenderingContext2D;

    draw(context);

  }, [ draw, image ]);
  
  if (!image) {
    return null;
  }
  
  return <canvas ref={canvasRef} width={image.width} height={image.height} title={props.alt} />
}